import { createContext, useContext } from 'react';

// Shared PESO office context object, kept in its own module so both the provider
// (PesoOfficeContext.js) and the layout (PesoLayout.js, which the provider renders
// as its loading fallback) can import it without a circular dependency.
export const OfficeCtx = createContext(null);
export const useOffice = () => useContext(OfficeCtx);
